import React from "react";

/**
 * PageWrapper
 * - Small shared wrapper to keep pages consistent (matches Report.jsx layout)
 * - Accepts optional title prop to render a page heading
 */

const PageWrapper = ({ children }) => {
  return (
    <div className="flex flex-col items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="w-full max-w-md md:max-w-7xl">{children}</div>
    </div>
  );
};

export default PageWrapper;
